<div class="row mb-5 doc-vente-doc-form" style="margin-top:2%">
    <div class="col-12">
        <div class="row mb-3 align-items-end">
            <div class="col-lg-4 col-md-6 mb-3 mb-md-0">
                <label class="d-block mb-1" for="labelBonSortie">Label</label>
                <input
                    id="labelBonSortie"
                    type="text"
                    class="form-control"
                    name="labelBonSortie"
                    [(ngModel)]="labelText"
                    [placeholder]="documentTypeLabel"
                />
            </div>
            <div class="col-lg-4 col-md-6">
                <label class="d-block mb-1" for="couleurBonSortie">Couleur du document</label>
                <div class="doc-vente-color-wrap">
                    <span class="doc-vente-color-value">{{ couleurText }}</span>
                    <input
                        id="couleurBonSortie"
                        type="color"
                        class="doc-vente-color-input"
                        name="couleurBonSortie"
                        [(ngModel)]="couleurText"
                        title="Choisir une couleur"
                    />
                </div>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="bsContactCheckbox" name="bsMt" [(ngModel)]="affMontantTotaux">
                <label class="custom-control-label" for="bsContactCheckbox">
                    Afficher les montants totaux
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="bsContact" name="bsContact" [(ngModel)]="affInfContact">
                <label class="custom-control-label" for="bsContact">
                    Afficher les informations de contact
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="bsDesc" name="bsDesc" [(ngModel)]="affCourteDesp">
                <label class="custom-control-label" for="bsDesc">
                    Afficher une courte description
                </label>
            </div>
        </div>
        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="bsInfo" name="bsInfo" [(ngModel)]="affInfos">
                <label class="custom-control-label" for="bsInfo">
                    Afficher les informations
                </label>
            </div>
        </div>

        <div class="mb-1"><hr class="m-0 divis"></div>

        <div class="mb-2">
            <label class="form-check-label label-large d-block mb-2" for="noteBonSortie">
                Note
            </label>
            <textarea id="noteBonSortie" class="form-control note" name="noteBonSortie" [(ngModel)]="noteText" placeholder="Saisissez une note" rows="4"></textarea>
        </div>
    </div>
</div>

<div class="d-flex justify-content-end align-items-center flex-wrap w-100 position-fixed-bottom mt-2 mb-2">
    <a class="btn btn-grey waves-effect m-1" routerLink="/main/parametre/document">Annuler</a>
    <button type="button" class="btn btn-green waves-effect m-1" (click)="appercue()">Aperçu de la configuration</button>
    <button type="button" class="btn btn-primary  m-1" (click)="saveParametreDocument()" [disabled]="saving">{{ saving ? 'Enregistrement…' : 'Enregistrer' }}</button>
</div>
